import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionService {
  constructor(private http: HttpClient) {

  }


  apiCheckTermsAndCondition(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/check/terms-and-condition', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }

  apiCreateOrUpdateTermsAndCondition(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/create/terms-and-condition', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
}


interface StateResult<T> {
  status: number,
  result: T  
}